(function () {
  function el(root, sel) { return root ? root.querySelector(sel) : null; }
  function els(root, sel) { return root ? Array.from(root.querySelectorAll(sel)) : []; }

  function safeJsonParse(txt) {
    try { return JSON.parse(txt); } catch { return null; }
  }

  function moneyFromCents(cents) {
    const v = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat(undefined, { style: "currency", currency: "USD" }).format(v);
  }

  function coercePriceToCents(x) {
    if (x == null) return 0;
    const n = Number(x);
    if (!Number.isFinite(n)) return 0;

    if (!Number.isInteger(n) && n < 1000) return Math.round(n * 100);

    return Math.round(n);
  }

  function setCardLoading(card, isLoading) {
    if (!card) return;
    const sk = el(card, ".inkd-swag__imgSkeleton");
    const img = el(card, "img.inkd-swag__img");
    if (sk) sk.style.display = isLoading ? "" : "none";
    if (img && isLoading) img.hidden = true;
  }

  async function fetchProductByHandle(handle) {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: "same-origin",
      headers: { "Accept": "application/json" },
      cache: "no-store",
    });
    if (!res.ok) throw new Error(`Failed product fetch: ${handle}`);
    return await res.json();
  }

  function findColorOptionIndex(product) {
    const opts = Array.isArray(product?.options) ? product.options : [];

    const names = opts.map(o => {
      if (typeof o === "string") return o;
      if (o && typeof o === "object") return o.name || "";
      return "";
    });

    const idx = names.findIndex(n => /\bcolou?r\b/i.test(String(n || "")));
    return idx;
  }

  function getVariantOptionValue(variant, idx) {
    if (!variant || idx == null || idx < 0) return "";

    if (Array.isArray(variant.options) && variant.options[idx] != null) {
      return String(variant.options[idx] || "").trim();
    }

    const key = idx === 0 ? "option1" : idx === 1 ? "option2" : "option3";
    return String(variant[key] || "").trim();
  }

  function renderSwatches(card, product) {
    const wrap = el(card, '[data-field="swatches"]');
    if (!wrap) return;

    wrap.innerHTML = "";

    const colorIdx = findColorOptionIndex(product);
    if (colorIdx < 0) return;

    const vals = [];
    const seen = new Set();

    (product.variants || []).forEach(v => {
      const name = getVariantOptionValue(v, colorIdx);
      if (!name) return;

      const k = name.toLowerCase();
      if (seen.has(k)) return;
      seen.add(k);
      vals.push(name);
    });

    if (!vals.length) return;

    const max = 6;
    const show = vals.slice(0, max);
    const swatchApi = window.INKD_SWATCH_MAP;

    show.forEach(name => {
      const dot = document.createElement("span");
      dot.className = "inkd-swag__swatch";
      dot.setAttribute("aria-label", name);
      dot.setAttribute("title", name);
      dot.setAttribute("data-color-name", name);

      dot.style.backgroundColor = "#e9e9e9";

      const hex = swatchApi?.getHex ? swatchApi.getHex(name) : null;
      if (hex) dot.style.backgroundColor = hex;

      wrap.appendChild(dot);
    });

    if (vals.length > max) {
      const more = document.createElement("span");
      more.className = "inkd-swag__swatchMore";
      more.textContent = `+${vals.length - max}`;
      wrap.appendChild(more);
    }
  }

  async function hydrateCard(card, cfg) {
    if (!card || !cfg || !cfg.handle) return;

    setCardLoading(card, true);
    card.style.opacity = "1";
    card.style.display = "";

    const link = el(card, '[data-field="url"]');
    if (link) {
      link.href = `/products/${cfg.handle}`;
      link.setAttribute("aria-label", `View product`);
    }

    try {
      const p = await fetchProductByHandle(cfg.handle);

      const img = el(card, "img.inkd-swag__img");
      const title = el(card, '[data-field="title"]');
      const price = el(card, '[data-field="price"]');

      const imgUrl = (p.images && p.images[0]) ? p.images[0] : (p.featured_image || "");
      const minPriceCents = coercePriceToCents(p.price ?? p.variants?.[0]?.price ?? 0);

      if (img && imgUrl) {
        img.src = imgUrl;
        img.alt = p.title || "";
        img.hidden = false;
      }

      if (title) title.textContent = p.title || "";
      if (price) price.textContent = moneyFromCents(minPriceCents);

      if (link) {
        link.href = p.url || `/products/${p.handle || cfg.handle}`;
        link.setAttribute("aria-label", `View ${p.title || "product"}`);
      }

      renderSwatches(card, p);
    } catch (err) {
      card.style.opacity = "0.7";
      console.warn("[INKD] Couldn’t hydrate card:", cfg.handle, err?.message || err);
    } finally {
      setCardLoading(card, false);
    }
  }

  const ROOT = window.Shopify?.routes?.root || "/";
  const PREDICTIVE_LIMIT = 10;
  const TOTAL_LIMIT = 13;

  const SLOT_ROLES = [
    "featured",
    "mini-1",
    "mini-2",
    "small-1",
    "small-2",
    "featured-2",
    "mini-3",
    "mini-4",
    "small-3",
    "small-4",
    "equal-1",
    "equal-2",
    "equal-3",
  ];

  const STATE = new WeakMap();

  function getQFromUrl() {
    try { return (new URL(location.href)).searchParams.get("q") || ""; }
    catch { return ""; }
  }

  function setQInUrl(q) {
    try {
      const u = new URL(location.href);
      if (q) u.searchParams.set("q", q);
      else u.searchParams.delete("q");
      history.replaceState({}, "", u.toString());
    } catch {}
  }

  function normalizeHandle(raw) {
    return String(raw || "").trim().replace(/^\/products\//, "").replace(/^\//, "");
  }

  async function fetchPredictiveItems(q) {
    const params = new URLSearchParams();
    params.set("q", q);
    params.set("resources[type]", "product");
    params.set("resources[limit]", String(PREDICTIVE_LIMIT));
    params.set("resources[limit_scope]", "each");
    params.set("resources[options][unavailable_products]", "last");

    const res = await fetch(`${ROOT}search/suggest.json?${params.toString()}`, {
      method: "GET",
      credentials: "same-origin",
      headers: { "Accept": "application/json" },
      cache: "no-store",
    });

    const txt = await res.text();
    const data = safeJsonParse(txt) || {};

    if (!res.ok) {
      throw new Error(`Predictive ${res.status}: ${txt.slice(0, 200)}`);
    }

    const products = data?.resources?.results?.products || [];

    return products
      .map(p => ({
        handle: normalizeHandle(p?.handle || p?.url || ""),
        title: p?.title || "",
        url: p?.url || "",
      }))
      .filter(x => x.handle);
  }

  async function fetchSearchFallbackItems(q) {
    const res = await fetch(`${ROOT}search?view=json&q=${encodeURIComponent(q)}&type=product&options[prefix]=last`, {
      method: "GET",
      credentials: "same-origin",
      headers: { "Accept": "application/json" },
      cache: "no-store",
    });

    const txt = await res.text();
    const data = safeJsonParse(txt) || {};

    if (!res.ok) {
      throw new Error(`Search fallback ${res.status}: ${txt.slice(0, 200)}`);
    }

    const products = Array.isArray(data?.products) ? data.products : [];

    return products
      .map(p => ({
        handle: normalizeHandle(p?.handle || p?.url || ""),
        title: p?.title || "",
        url: p?.url || "",
      }))
      .filter(x => x.handle);
  }

  async function fetchShopifyItems(q) {
    const predictive = await fetchPredictiveItems(q);

    const seen = new Set();
    const out = [];

    predictive.forEach(item => {
      if (!item.handle || seen.has(item.handle)) return;
      seen.add(item.handle);
      out.push(item);
    });

    if (out.length < TOTAL_LIMIT) {
      try {
        const fallback = await fetchSearchFallbackItems(q);
        fallback.forEach(item => {
          if (!item.handle || seen.has(item.handle)) return;
          seen.add(item.handle);
          out.push(item);
        });
      } catch (e) {
        console.warn("[INKD] Fallback search failed:", e?.message || e);
      }
    }

    return out.slice(0, TOTAL_LIMIT);
  }

  async function runSearch(section, q) {
    q = String(q || "").trim();
    if (!q) return;

    const input = el(section, ".inkd-swag__searchInput");
    if (input) input.value = q;

    section.classList.add("is-loading");

    const cardsByRole = {};
    SLOT_ROLES.forEach(role => {
      const card = el(section, `[data-role="${role}"]`);
      if (card) {
        cardsByRole[role] = card;
        setCardLoading(card, true);
        card.style.display = "";
        card.style.opacity = "1";
      }
    });

    const token = Symbol("searchToken");
    section.__inkdSearchToken = token;

    try {
      const items = await fetchShopifyItems(q);
      if (section.__inkdSearchToken !== token) return;

      const slotItems = items.slice(0, SLOT_ROLES.length);

      STATE.set(section, {
        lastItems: items,
        baselineSlots: slotItems.slice(),
        currentSlots: slotItems.slice(),
        lastQuery: q,
      });

      const tasks = slotItems.map((it, i) => {
        const role = SLOT_ROLES[i];
        const card = cardsByRole[role];
        if (!card) return null;
        return hydrateCard(card, { handle: it.handle });
      }).filter(Boolean);

      await Promise.all(tasks);
      if (section.__inkdSearchToken !== token) return;

      for (let i = slotItems.length; i < SLOT_ROLES.length; i++) {
        const card = cardsByRole[SLOT_ROLES[i]];
        if (card) card.style.display = "none";
      }
    } catch (e) {
      console.warn("[INKD] Search failed:", e?.message || e);
      const first = el(section, `[data-role="featured"]`) || el(section, `[data-role="featured-2"]`);
      if (first) first.style.opacity = "0.85";
    } finally {
      Object.values(cardsByRole).forEach(card => setCardLoading(card, false));
      if (section.__inkdSearchToken === token) {
        section.classList.remove("is-loading");
      }
    }
  }

  function initSection(section) {
    if (!section || section.__inkdBound) return;
    section.__inkdBound = true;

    section.addEventListener("click", (e) => {
      const card = e.target.closest(".inkd-swag__card");
      if (!card) return;

      if (e.target.closest("a, button, input, label, select, textarea")) return;

      const a = card.querySelector(".inkd-swag__stretchedLink");
      const href = a?.getAttribute("href");
      if (!href || href === "#") return;

      window.location.assign(href);
    });

    const chips = els(section, ".inkd-swag__chip");
    const input = el(section, ".inkd-swag__searchInput");
    const showMe = el(section, ".inkd-swag__searchBtn");

    function run(q) {
      q = String(q || "").trim();
      if (!q) return;
      setQInUrl(q);
      runSearch(section, q);
    }

    if (showMe && input) {
      showMe.addEventListener("click", () => run(input.value));
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          run(input.value);
        }
      });
    }

    chips.forEach(btn => {
      btn.addEventListener("click", () => {
        chips.forEach(b => b.classList.remove("is-active"));
        btn.classList.add("is-active");
        const q = (btn.textContent || "").trim();
        if (input) input.value = q;
        run(q);
      });
    });

    const q0 = getQFromUrl().trim();
    if (q0) run(q0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll(".inkd-swag[data-section-id]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();